export const environment = {
  production: false,
  environment: 'dev',
  firebase: {
    apiKey: "AIzaSyD4fieCG2BC1SAbAacnCzLV-lYC2Vd_84k",
    authDomain: "up-forsale-admin-dev.firebaseapp.com",
    projectId: "up-forsale-admin-dev",
    storageBucket: "up-forsale-admin-dev.firebasestorage.app",
    messagingSenderId: "298855921698",
    appId: "1:298855921698:web:b8a16856c0123fbda7327b",
    measurementId: "G-JJV0CEH6RE"
  },
  appCheck: {
    // reCAPTCHA Enterprise site key for App Check
    siteKey: "6LfNbjEsAAAAAOx4b_4OZSUKwkNPIhICEJcXxY5x"
  },
  api: {
    baseUrl: "https://australia-southeast1-up-forsale-data-dev.cloudfunctions.net"
  },
  loadBalancer: {
    // HTTPS Load Balancer URLs for Cloud Armor protection
    // Using domain (requires DNS configuration and SSL certificate provisioning)
    adminDev: "https://australia-southeast1-up-forsale-admin-dev.cloudfunctions.net"
  }
};






